import { Container } from "@mantine/core"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum,
  useFindFaqByLanguage,
} from "~/gen/api"
import { i18n } from "~/i18n"
import { FAQContent } from "~/pages/Brand/FAQ/FAQContent.tsx"

export const FAQ = () => {
  const lang = i18n.language
    .split("-")[0]
    .toUpperCase() as keyof typeof findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum

  const faqQuery = useFindFaqByLanguage(
    findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum[lang]
  )

  return (
    <Container fluid py="xl" px="lg">
      <DataFetchWrapper query={faqQuery}>
        {({ data }) => <FAQContent faqs={data.data} />}
      </DataFetchWrapper>
    </Container>
  )
}
